// src/services/groupService.js
import api from "../api/axios";

// ← عدّل لو accounts.urls متركّبة تحت prefix تاني في urls الرئيسي (مثلاً "/auth")
const BASE = "/auth";

const get = (url, params) => api.get(`${BASE}${url}`, { params }).then((r) => r.data);
const post = (url, body) => api.post(`${BASE}${url}`, body).then((r) => r.data);
const patch = (url, body) => api.patch(`${BASE}${url}`, body).then((r) => r.data);
const del = (url) => api.delete(`${BASE}${url}`).then((r) => r.data);
// تحميل PDF كـ Blob. لما الـ responseType بلوب، رسالة الخطأ بتيجي Blob،
// فبنحولها JSON عشان getErrorMessage تقراها.
const getPdf = async (url, params) => {
  try {
    const r = await api.get(`${BASE}${url}`, { params, responseType: "blob" });
    return r.data;
  } catch (e) {
    if (e?.response?.data instanceof Blob) {
      try {
        e.response.data = JSON.parse(await e.response.data.text());
      } catch {
        /* سيب الرسالة الافتراضية */
      }
    }
    throw e;
  }
};

export function getErrorMessage(err, fallback = "حدث خطأ غير متوقع، حاول مرة أخرى") {
  const data = err?.response?.data;
  return (
    data?.error_message ||
    data?.detail ||
    (err?.response ? fallback : "تعذّر الاتصال بالسيرفر، تأكد من الإنترنت")
  );
}

export const groupService = {
  // ───────── المدرس ─────────
  getDashboard: (days = 7) => get("/teacher/dashboard/", { days }),

  listGroups: (params) => get("/teacher/groups/", params),
  createGroup: (data) => post("/teacher/groups/", data),
  getGroup: (id) => get(`/teacher/groups/${id}/`),
  updateGroup: (id, data) => patch(`/teacher/groups/${id}/`, data),
  deleteGroup: (id) => del(`/teacher/groups/${id}/`),

  listGroupStudents: (id, params) => get(`/teacher/groups/${id}/students/`, params),
  addStudents: (id, studentIds) => post(`/teacher/groups/${id}/students/`, { student_ids: studentIds }),
  getStudentProgress: (id, studentId) => get(`/teacher/groups/${id}/students/${studentId}/`),
    // ───────── المدرس ─────────
  getStudentReport: (id, studentId, params) =>
    getPdf(`/teacher/groups/${id}/students/${studentId}/report/`, params),

  // ───────── الأدمن ─────────
  adminGetStudentReport: (id, studentId, params) =>
    getPdf(`/admin/teacher-groups/${id}/students/${studentId}/report/`, params),

    getStudentReportOptions: (id, studentId) =>
    get(`/teacher/groups/${id}/students/${studentId}/report/options/`),

  adminGetStudentReportOptions: (id, studentId) =>
    get(`/admin/teacher-groups/${id}/students/${studentId}/report/options/`),
  removeStudent: (id, studentId) => del(`/teacher/groups/${id}/students/${studentId}/`),
  bulkRemove: (id, studentIds) => post(`/teacher/groups/${id}/students/remove/`, { student_ids: studentIds }),
  moveStudents: (id, payload) => post(`/teacher/groups/${id}/students/move/`, payload),

  getStats: (id, days = 7) => get(`/teacher/groups/${id}/stats/`, { days }),
  getLeaderboard: (id, limit = 10) => get(`/teacher/groups/${id}/leaderboard/`, { limit }),
  getInactive: (id, params) => get(`/teacher/groups/${id}/inactive-students/`, params),

  listMyStudents: (params) => get("/teacher/students/", params),
  searchStudents: (q, excludeGroup) =>
    get("/teacher/students/search/", { q, ...(excludeGroup ? { exclude_group: excludeGroup } : {}) }),

  // ───────── الأدمن ─────────
  adminListGroups: (params) => get("/admin/teacher-groups/", params),
  adminCreateGroup: (data) => post("/admin/teacher-groups/", data), // ← NEW: {teacher_id, name, description, is_active}
  adminGetGroup: (id) => get(`/admin/teacher-groups/${id}/`),
  adminDeleteGroup: (id) => del(`/admin/teacher-groups/${id}/`),
  adminGroupStudents: (id, params) => get(`/admin/teacher-groups/${id}/students/`, params),
  adminAddStudents: (id, studentIds) => post(`/admin/teacher-groups/${id}/students/`, { student_ids: studentIds }), // ← NEW
  adminSearchStudents: (q, excludeGroup) =>
    get("/admin/students/search/", { q, ...(excludeGroup ? { exclude_group: excludeGroup } : {}) }), // ← NEW
  adminTransfer: (id, teacherId) => post(`/admin/teacher-groups/${id}/transfer/`, { teacher_id: teacherId }),
  getTeachers: () => get("/teachers/"),
};